import { action, makeObservable, observable } from "mobx";
import { ShopGoodInclude } from "../../../interfaces";

export class ShopGoodIncludeStore implements ShopGoodInclude {
	@observable id = 0;
	@observable shop_good_id = 0;
	@observable descriptions = "";

	constructor(initialData: ShopGoodInclude | null) {
		makeObservable(this);

		if (initialData) {
			this.fillStore(initialData);
		}
	}

	@action
	fillStore(data: ShopGoodInclude) {
		const { id, shop_good_id, descriptions } = data;

		this.id = id;
		this.shop_good_id = shop_good_id;
		this.descriptions = descriptions;
	}
}
